import { IconButton, styled, useTheme } from "@mui/material";
import { closeSnackbar, MaterialDesignContent, SnackbarProvider } from "notistack";
import CheckIcon from "../../../../assets/interfase/checkIcon";
import CloseMenuIcon from "../../../../assets/menu/closeMenuIcon";
import InfoIcon from "../../../../assets/warning/infoIcon";
import StopSignIcon from "../../../../assets/warning/stopSignIcon";
import { DEFAULT_SNACKBAR_DURATION } from "../../../../themes/config";

const SnackbarProviderExtended = (props) => {
	const theme = useTheme();
	const { primary, info, warning, success, error } = theme.palette;
	const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
		'&.notistack-MuiContent-success': {
			borderRadius: '12px',
			backgroundColor: success.lighter,
			color: primary[700],
			borderLeft: `3px solid ${success.dark}`
		},
		'&.notistack-MuiContent-warning': {
			borderRadius: '12px',
			backgroundColor: warning.lighter,
			color: primary[700],
			borderLeft: `3px solid ${warning.dark}`
		},
		'&.notistack-MuiContent-error': {
			borderRadius: '12px',
			backgroundColor: error.lighter,
			color: primary[700],
			borderLeft: `3px solid ${error.dark}`
		},
		'&.notistack-MuiContent-info': {
			borderRadius: '12px',
			backgroundColor: info.lighter,
			color: primary[700],
			borderLeft: `3px solid ${info.dark}`
		},
	}));
	
	return (
		<SnackbarProvider
			maxSnack={8}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			Components={{
				success: StyledMaterialDesignContent,
				error: StyledMaterialDesignContent,
				warning: StyledMaterialDesignContent,
				info: StyledMaterialDesignContent
			}}
			iconVariant={{
				success: <CheckIcon color={success.dark}/>,
				error: <StopSignIcon color={error.dark}/>,
				warning: <InfoIcon color={warning.dark}/>,
				info: <InfoIcon color={info.dark}/>
			}}
			dense={true}
			preventDuplicate={true}
			autoHideDuration={DEFAULT_SNACKBAR_DURATION}
			action={(snackbarId) => (
				<IconButton
					onClick={() => closeSnackbar(snackbarId)}
				>
					<CloseMenuIcon color={'#5E666B'}/>
				</IconButton>
			)}
		>
			{props.children}
		</SnackbarProvider>
	);
};

export default SnackbarProviderExtended